import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  greetings: localStorage.getItem('press') && JSON.parse(localStorage.getItem('press'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/press/index.js